import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../actions/arts";
import { getServices } from "../../../actions/providedServices";
import ProviderProvidedServiceSearchForm from "./artProvidedServiceSearchForm";

const initialValues = {
  art: "",
};

const ArtProvidedServiceSearchFormContainer = ({ }) => {
  const dispatch = useDispatch();
  const art = useSelector((state) => state.arts);
  const loading = art.isFetching;

  useEffect(() => {
    dispatch(getArts());
  }, []);

  const handleSubmitSearch = (values) => {
    dispatch(getServices(values.art));
  }

  return <ProviderProvidedServiceSearchForm
    initialValues={initialValues}
    loading={loading}
    arts={art.list}
    handleSubmitSearch={handleSubmitSearch}
  />;
};

export default ArtProvidedServiceSearchFormContainer;